import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	Opened: true as boolean | null,
	Approved: null as boolean | null,
	Rejected: null as boolean | null,
	CreatedFrom: null as Date | null,
	CreatedTo: null as Date | null,
	NdNr: null as string | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
